module.exports = __webpack_public_path__ + "media/images/tailwind/facebook-973c2cda46b952e47a1c110ceed0c01c.png";